/**
 * TM-1000001726 Phase 3: Frontend-Spiegel des Backend-Enums
 * {@code CrudOperationEnum}. Definiert die vier von der CRUD-Activity-Logic
 * unterstuetzten Operationen.
 *
 * @ticket TM-1000001726
 */
export enum CrudOperationEnum {
    INSERT,
    UPDATE,
    DELETE,
    READ
}
